import { useLanguage } from "../context/LanguageContext";
import { useRefonte } from "../translations/refonte";

/** Petite carte vivante posée sur la capture du hero : une pratique qui passe d'une étape à la suivante. */
export const LiveLevelCard = () => {
  const { language } = useLanguage();
  const c = useRefonte(language).liveCard;

  return (
    <div
      className="hidden lg:block absolute -top-10 -right-4 xl:-right-8 w-[250px] bg-white border border-linec-300 rounded-xl p-4 shadow-[0_22px_50px_-18px_rgba(10,35,66,0.4)] z-10"
      data-testid="hero-live-card"
    >
      <div className="flex items-center justify-between mb-3">
        <span className="mono-cayus text-inkc-400">{c.label}</span>
        <span className="w-2 h-2 rounded-full bg-[#10B981] live-dot" />
      </div>

      <p className="font-bold text-base text-inkc-800 tracking-[-0.02em] mb-3">{c.practice}</p>

      <div className="h-1.5 w-full bg-linec-200 rounded-full overflow-hidden mb-3">
        <div className="h-full bg-[linear-gradient(90deg,#5EB3F6,#0047AB)] rounded-full live-bar" style={{ width: "22%" }} />
      </div>

      <div className="relative h-5">
        <p className="absolute inset-0 text-sm text-inkc-500 live-from">{c.from}</p>
        <p className="absolute inset-0 text-sm font-semibold text-cobalt-600 live-to">{c.to}</p>
      </div>

      <p className="text-xs text-inkc-400 mt-2.5 border-t border-linec-200 pt-2.5">{c.evidence}</p>
    </div>
  );
};

export default LiveLevelCard;
